import React from 'react';
import { PropTypes } from 'prop-types';
import ReactLinkify from 'react-linkify';

const TrWithLabelAndValue = ({ item, values }) => (
  <tr>
    <td className="w-44 font-normal text-vamos-gray" valign="top">{`${item.label}`} </td>
    <td className="mb-0 text-left break-words whitespace-normal" valign="top">
      <ReactLinkify>
        {values[item.key] || 'N/A'}
      </ReactLinkify>
    </td>
  </tr>
);

TrWithLabelAndValue.propTypes = {
  item: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
};

export default TrWithLabelAndValue;
